import WhatsAppLogo from '@assets/whatsapp.png';
import { useLocation } from 'react-router';

export function WhatsAppButton() {
  const { pathname } = useLocation();

  if (pathname.includes('/topicos/')) {
    return null;
  }

  return (
    <a
      className="fixed bottom-4 right-4"
      href="https://api.whatsapp.com/send?phone=5517996261009"
      target="_blank">
      <img alt="WhatsApp logo" className="size-12" src={WhatsAppLogo} />
    </a>
  );
}
